<template>
  <div>
    <AddCategory/>
  </div>
</template>

<script>
import AddCategory from "./add-category";

export default {
  components: {
    AddCategory
  }
};
</script>